import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import ReactMde from 'react-mde'
import * as Showdown from 'showdown'
import xssFilter from 'showdown-xss-filter'

import './react-mde.scss'

class ReactMDE extends PureComponent {
  constructor() {
    super()
    this.state = {
      tab: 'write',
    }
    this.converter = new Showdown.Converter({
      tables: true,
      simplifiedAutoLink: true,
      strikethrough: true,
      tasklists: true,
      extensions: [xssFilter],
    })
  }
  handleTabChange = (tab) => {
    this.setState({ tab })
  }
  render() {
    const { handleValueChange, body, placeholder } = this.props
    const { tab } = this.state

    return (
      <ReactMde
        onChange={handleValueChange}
        onTabChange={this.handleTabChange}
        value={body}
        textAreaProps={{
          placeholder,
        }}
        generateMarkdownPreview={(markdown) =>
          Promise.resolve(this.converter.makeHtml(markdown))
        }
        selectedTab={tab}
      />
    )
  }
}

ReactMDE.propTypes = {}

export default ReactMDE
